export default "float quinticOut(float t) {\n  return 1.0 - (pow(t - 1.0, 5.0));\n}\n\n"